import React from 'react';

import { Address, Copy, Social } from './components';
import { ButtonUp } from '@components';

import * as styles from './Footer.module.scss';

export const Footer: React.FC = () => {
	return (
		<footer className={styles.footer}>
			<div className={styles.flex}>
				<Address />
				<div className={styles.flexSection}>
					<Social />
					<ButtonUp />
				</div>
			</div>
			<Copy />
		</footer>
	);
};
